import React from 'react';

const ArrowLeftIcon = () => {
    return (
        <svg width="10" height="19" viewBox="0 0 10 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.1739 18.25C8.97483 18.251 8.78378 18.1717 8.6439 18.03L0.643901 10.03C0.351447 9.73721 0.351447 9.26285 0.643901 8.97003L8.6439 0.97003C8.93941 0.694671 9.39991 0.702796 9.68552 0.988408C9.97113 1.27402 9.97926 1.73452 9.7039 2.03003L2.2339 9.50003L9.7039 16.97C9.99635 17.2628 9.99635 17.7372 9.7039 18.03C9.56402 18.1717 9.37297 18.251 9.1739 18.25Z" fill="current"/>
        </svg>
    );
};

export default ArrowLeftIcon;